<template>
  <div>
    <section class="p-box">
      <header class="p-box__header">
        <KkFilterModal
          :is-visible="showFilterModal"
          :filter-items="filterItems"
          :form-values="formValues"
          :total-count="filteredCount"
          @close="showFilterModal = false"
          @submit="handleSubmit"
          @reset="reset"
          @change-check-box="handleChangeFilterModalCheckBox"
        />
        <div class="p-filtersA">
          <div class="p-filtersA__left">
            <KkFilterButton @click="showFilterModal = !showFilterModal" />
          </div>
          <div class="p-filtersA__left" />
          <div class="p-filtersA__right">
            <div class="c-searchField">
              <input
                v-model="searchQuery"
                type="text"
                class="searchForm"
                :placeholder="$t('labels.locationOrStoreCodeSearch')"
                @keydown.enter="search"
              >
              <Icon name="iconSearch" />
            </div>
          </div>
        </div>
      </header>
      <div class="p-box__body">
        <Loading v-show="stores_loading" />
        <template v-if="stores && !stores_loading">
          <div v-if="stores.data.length">
            <div class="p-stores">
              <div
                v-for="(store, i) in stores.data"
                :key="i"
                class="p-stores__item"
              >
                <div class="p-stores__brand">
                  <div class="p-stores__brand__icon">
                    <img :src="store.attributes.brand_image_url" alt="">
                  </div>
                </div>
                <div class="p-stores__content p-stores__content--fixedWidth">
                  <p class="p-stores__name">{{ store.attributes.name }}</p>
                  <p class="p-stores__publication" :class=" !store.attributes.visible && 'is-private'">
                    <StatusBadge :status="extractStatusNumber(store.attributes.visible)" />
                    {{ store.attributes.visible ? $t('labels.visible') : $t('labels.invisible') }}
                  </p>
                  <p class="p-stores__code">{{ $t('models.store.code') }}：{{ truncateCode(store.attributes.code) }}</p>
                </div>
                <div class="p-stores__services">
                  <ul class="c-services">
                    <li
                      v-for="( store_site, j ) in store.attributes.store_sites.filter(store_site => store_site.visible)"
                      :key="j"
                      class="c-services__item"
                    >
                      <span>
                        <KkSiteIcon :name="store_site.site_type" />
                      </span>
                    </li>
                  </ul>
                </div>
                <div class="p-stores__action">
                  <router-link v-if="showMoreThanEditorAuthority" :to="`/s/companies/${ $route.params.company_uuid }/visitor/stores/${store.attributes.uuid}/edit`" class="p-stores__action__item">
                    <img :src="iconPencilPath" alt="" class="p-stores__action__icon">
                    {{ $t('labels.edit') }}
                  </router-link>
                  <span class="p-stores__action__item downloadQrCode" @click="generateZip(store)">
                    <KkIcon name="iconDownload" />
                    {{ $t('pages.CompaniesVisitorStore.downloadQrCode') }}
                  </span>
                </div>
              </div>
            </div>
          </div>
          <div v-else v-text="$t('messages.noData')" />
          <div v-if="stores.meta.total_pages" class="p-controller">
            <div class="p-controller__count">
              <p class="p-controller__count__name">{{ $t('labels.perPageCount') }}</p>
              <div class="p-controller__count__select">
                <select :value="displayNumber" @change="changeDisplayNumber($event)">
                  <option v-for="item in 5" :key="item" :value="item * 50">{{ item * 50 }}</option>
                </select>
              </div>
              <p class="p-controller__count__current">{{ startDataNumber }}-{{ endDataNumber }}</p>
            </div>
            <div class="p-controller__navi">
              <button
                type="button"
                :disabled="stores_loading || currentPage === 1"
                class="p-controller__navi__prev"
                @click="goPrevPage"
              >
                <Icon name="arrowLeft" />
              </button>
              <button
                type="button"
                :disabled="stores_loading || currentPage >= stores.meta.total_pages"
                class="p-controller__navi__next"
                @click="goNextPage"
              >
                <Icon name="arrowRight" />
              </button>
            </div>
          </div>
          <!-- <div class="c-button c-button--right">
            <div>
              {{ stores.meta.store_count }} / {{ stores.meta.max_store_count }} {{ $t('labels.registeredStoresCount') }}
            </div>
            <div v-if="canAddStores()">
              <a :href="`/s/companies/${ companyUuid }/location/stores/new`" class="c-button__item c-button__item--primary">
                <img :src="iconPlusPath" alt="" class="c-button__icon">
                {{ $t('labels.registerNewStore') }}
              </a>
            </div>
            <div v-else>
              <a :href="`/s/companies/${ companyUuid }/payment_settings`" class="c-button__item c-button__item--primary">
                <img :src="iconPlusPath" alt="" class="c-button__icon">
                {{ $t('labels.upgradePlanAndRegisterNewStore') }}
              </a>
            </div>
          </div> -->
        </template>
      </div>
    </section>
  </div>
</template>

<script>
import { mapState, mapActions, mapGetters, mapMutations } from 'vuex'
import Loading from '../components/Loading.vue'
import Icon from '../components/Icon.vue'
import iconPlusPath from '../../../images/common/icon_plus.svg'
import iconPencilPath from '../../../images/common/icon_pencil.svg'
import iconCrossPath from '../../../images/common/icon_cross.svg'
import StatusBadge from '../components/StatusBadge'
import { KkIcon, KkSiteIcon } from '../components/base'
import QRCode from 'qrcode'
import JSZip from 'jszip'
import { removeAllSpaces } from '../modules/string_converter'
import {
  KkFilterButton
} from '../components/ui'
import {
  KkFilterModal
} from '../components/projects'
import { addAttributes } from '../modules/filterModalConst'

export default {
  name: 'CompaniesVisitorStores',
  components: {
    Loading,
    Icon,
    KkSiteIcon,
    StatusBadge,
    KkIcon,
    KkFilterButton,
    KkFilterModal,
  },
  beforeRouteEnter(to, form, next) {
    if (to.query.per === undefined) {
      next(vm => vm.setDisplayNumber(vm.displayNumber))
    } else {
      next()
    }
  },
  data () {
    return {
      currentUser: gon.currentUser,
      companyUuid: this.$route.params.company_uuid,
      searchQuery: this.$route.query['q[name_cont]'] || '',
      currentPage: Number(this.$route.query['page']) || 1,
      iconPlusPath,
      iconPencilPath,
      iconCrossPath,
      showFilterModal: false,
      filterItems: [],
    }
  },
  computed: {
    ...mapState({
      stores: state => state.companiesVisitorStores.data,
      stores_loading: state => state.companiesVisitorStores.loading,
      displayNumber: state => state.filters.displayNumber,
      company: state => state.companiesCompany.data,
      formValues: state => state.companiesSearchTagGroups.formValues,
      searchAttributesLoading: state => state.companiesSearchTagGroups.loading,
      searchAttributes: state => state.companiesSearchTagGroups.data,
      filteredCount: state => state.companiesVisitorStores.filteredCount,
    }),
    ...mapGetters({
      showMoreThanEditorAuthority: 'companiesAccessibleApi/showMoreThanEditorAuthority',
    }),
    readStoresParams() {
      const { visible_flags, brands, areas, franchisees, user_companies, prefectures, sites } = this.formValues
      return {
        companyUuid: this.companyUuid,
        params: {
          per: this.displayNumber,
          page: this.currentPage,
          q:{
            name_cont: this.searchQuery || undefined,
            option_code_cont: this.searchQuery || undefined,
            m: 'or',
          },
          search: {
            visible_flags: visible_flags === 0 ? undefined : visible_flags,
            brand_ids: (brands && brands.length === 0) ? undefined : brands,
            area_ids: areas === 0 ? undefined : areas,
            franchisee_ids: franchisees === 0 ? undefined : franchisees,
            user_company_ids: user_companies === 0 ? undefined : user_companies,
            prefectures: prefectures === 0 ? undefined : prefectures,
            site_types: sites === 0 ? undefined : sites,
            original_tag_group_a_tag_ids: this.formValues.original_tag_group_a,
            original_tag_group_b_tag_ids: this.formValues.original_tag_group_b,
            original_tag_group_c_tag_ids: this.formValues.original_tag_group_c,
            original_tag_group_d_tag_ids: this.formValues.original_tag_group_d,
            original_tag_group_e_tag_ids: this.formValues.original_tag_group_e,
            sort_key: this.sortKey,
            sort_order: this.sortOrder,
          },
        }
      }
    },
    startDataNumber: function () {
      return (this.currentPage - 1) * this.displayNumber + 1
    },
    endDataNumber: function () {
      return this.startDataNumber + this.stores.data.length - 1
    },
  },
  created: async function () {
    await Promise.all([
      this.readStores(this.readStoresParams),
      this.readSearchAttributes(),
    ])
    this.setFormValues(this.formInitialValues())
    this.createFilter()
  },
  methods: {
    ...mapActions({
      readStores: 'companiesVisitorStores/readStores',
      readStoresForFilter: 'companiesVisitorStores/readStoresForFilter',
      setDisplayNumber: 'filters/setDisplayNumber',
      readSearchAttributes: 'companiesSearchTagGroups/readSearchTagGroups',
    }),
    ...mapMutations({
      setFormValues: 'companiesSearchTagGroups/setFormValues',
    }),
    extractStatusNumber(status) {
      return status ? 1 : 2
    },
    goPrevPage() {
      --this.currentPage
      this.changePage()
    },
    goNextPage() {
      ++this.currentPage
      this.changePage()
    },
    changePage() {
      const query = { ...this.$route.query, 'page': this.currentPage }
      window.scrollTo({ top: 0 })
      this.handleQuerySubmit(query)
    },
    formInitialValues() {
      return {
        visible_flags:[],
        sites: [],
        brands: [],
        franchisees: [],
        areas: [],
        user_companies: [],
        prefectures: [],
        original_tag_group_a: [],
        original_tag_group_b: [],
        original_tag_group_c: [],
        original_tag_group_d: [],
        original_tag_group_e: [],
      }
    },
    /**
     * 表示件数の変更
     * @param  { Object } e イベントオブジェクト
     * @return { Void }
     */
    async changeDisplayNumber(e) {
      this.resetPage()
      await this.setDisplayNumber(e.target.value)
      this.readStores(this.readStoresParams)
    },
    search: function (event) {
      if (event.keyCode !== 13) return
      if (this.searchQuery === (this.$route.query['q[name_cont]'] || '')) return

      this.resetPage()
      const query = { ...this.$route.query, 'q[name_cont]': this.searchQuery || undefined, 'q[option_code_cont]': this.searchQuery || undefined, 'q[m]': 'or' }
      this.handleQuerySubmit(query)
    },
    resetPage: function () {
      this.currentPage = 1
      this.$route.query.page = undefined
    },
    async handleQuerySubmit(query) {
      await this.$router.push({ query: query })
      this.readStores(this.readStoresParams)
    },
    canAddStores: function () {
      return this.stores.meta.max_store_count > this.stores.data.length
    },
    truncateCode(code) {
      if (!code) return '-'
      if (code.length > 15) {
        return code.slice(0, 15) + '...'
      } else {
        return code
      }
    },
    qrCodeFileName(format, store) {
      return this.$t(
        'pages.CompaniesVisitorStoreEdit.qrcode.downloadButton.fileName',
        { companyName: removeAllSpaces(this.company.attributes.name), storeName: removeAllSpaces(store.attributes.name), format: format }
      )
    },
    createElementFromHTML(html) {
      const tempEl = document.createElement('div')
      tempEl.innerHTML = html
      return tempEl.firstElementChild
    },
    getDataURLFromSVG(svg) {
      const svgData = new XMLSerializer().serializeToString(this.createElementFromHTML(svg))
      return `data:image/svg+xml;base64, ${btoa(unescape(encodeURIComponent(svgData)))}`
    },
    generateQRCodeDataURL(link, format, options) {
      let dataUrl
      switch (format) {
      case 'img':
        QRCode.toDataURL(link, options, (error, url) => {
          if (error) throw error
          dataUrl = url
        })
        break
      case 'svg':
        QRCode.toString(link, options, (error, svg) => {
          if (error) throw error
          dataUrl = this.getDataURLFromSVG(svg)
        })
        break
      default:
        QRCode.toString(link, options, (error, string) => {
          if (error) throw error
          dataUrl = string
        })
      }
      return dataUrl
    },
    handleChangeFilterModalCheckBox({ kind, id }) {
      const newFormValues = Object.assign({}, this.formValues)
      if(newFormValues[kind].includes(id)) {
        newFormValues[kind] = newFormValues[kind].filter((_id) => _id !== id)
      } else {
        newFormValues[kind].push(id)
      }
      this.setFormValues(newFormValues)
      this.readStoresForFilter(this.readStoresParams)
    },
    /**
     * モーダルウィンドウ（絞り込み条件）を閉じる
     * @return { Void }
     */
    closeModal() {
      this.showFilterModal = false
    },
    reset() {
      this.setFormValues(this.formInitialValues())
      this.reloadAndQuerySubmit()
      this.handleSubmit()
    },
    createFilter() {
      const attributes = [
        this.searchAttributes.visible_flags,
        this.searchAttributes.sites,
        this.searchAttributes.brands,
        this.searchAttributes.areas,
        this.searchAttributes.franchisees,
        this.searchAttributes.user_companies,
      ]
      if(this.searchAttributes.original_tag_group_a) attributes.push(this.searchAttributes.original_tag_group_a)
      if(this.searchAttributes.original_tag_group_b) attributes.push(this.searchAttributes.original_tag_group_b)
      if(this.searchAttributes.original_tag_group_c) attributes.push(this.searchAttributes.original_tag_group_c)
      if(this.searchAttributes.original_tag_group_d) attributes.push(this.searchAttributes.original_tag_group_d)
      if(this.searchAttributes.original_tag_group_e) attributes.push(this.searchAttributes.original_tag_group_e)
      attributes.push(this.searchAttributes.prefectures)
      this.filterItems = attributes.map((attr) => {
        if(attr && attr.kind){
          return addAttributes(attr, attr.kind)
        }
      })
    },
    reloadAndQuerySubmit() {
      this.resetPage()
      this.readStores(this.readStoresParams)
    },
    /**
     * 絞り込み条件の変更
     * @return { Void }
     */
    handleSubmit() {
      this.reloadAndQuerySubmit()
      this.closeModal()
    },
    generateZip(store) {
      let zip = new JSZip()
      zip.file(this.qrCodeFileName('png', store), this.generateQRCodeDataURL(store.links.visitor, 'img').split(',')[1], {base64: true})
      zip.file(this.qrCodeFileName('svg', store), this.generateQRCodeDataURL(store.links.visitor, 'svg').split(',')[1], {base64: true})
      zip.generateAsync({type:'blob'}).then(content => {
        const link = document.createElement('a')
        link.href = URL.createObjectURL(content)
        link.download = this.qrCodeFileName('zip', store)
        link.click()
        URL.revokeObjectURL(link.href)
      })
    },
  }
}
</script>

<style lang="scss" scoped>
.searchForm {
  width: 220px;
}

.downloadQrCode {
  cursor: pointer;
  svg {
    width: 18px;
    margin-right: 8px;
  }
}
</style>
